<template>
    <textarea
        v-if="type === 'textarea'"
        class="
            border border-gray-200
            py-2
            px-4
            font-sans
            rounded-md
            block
            w-full
            hover:border-gray-300
            focus:border-primary;
        "
        v-bind="$attrs"
        :value="modelValue"
        @input="$emit('update:modelValue', $event.target.value)"
    ></textarea>
    <input
        v-else
        :type="type"
        class="
            border border-gray-200
            py-2
            px-4
            font-sans
            rounded-md
            block
            w-full
            hover:border-gray-300
            focus:border-primary
        "
        v-bind="$attrs"
        :value="modelValue"
        @input="$emit('update:modelValue', $event.target.value)"
    />
</template>

<script>
export default {
    name: "AppInput",
    props: ["type", "modelValue"],
};
</script>

<style scoped></style>
